export default function Input({
  label = "",
  inputSample = "",
  type = "",
  id = "",
  name = "",
  isReadOnly = true,
  isAuotComplete = false,
  isNumeric = false,
  isLTR = false,
  max,
  onChange,
  value,
  floatingLabel = false,
}) {
  if (floatingLabel) {
    return (
      <div
        className={`relative flex h-[42px] w-full items-center overflow-visible rounded-lg border-none transition-colors ${
          isReadOnly
            ? "border-transparent bg-transparent"
            : "border-zi-border-light bg-transparent dark:border-none dark:bg-zi-inputbg-dark hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-dark/50"
        }`}
      >
        <input
          defaultValue={inputSample}
          value={value}
          type={type}
          id={id}
          name={name}
          readOnly={isReadOnly}
          autoComplete={isAuotComplete}
          max={max}
          onInput={onChange}
          inputMode={isNumeric ? "numeric" : undefined}
          pattern={isNumeric ? "[0-9]*" : undefined}
          className={`zi-input-autofill h-full w-full bg-transparent px-3 text-start text-sm text-zi-text-light outline-none dark:text-zi-text-dark ${
            isLTR ? "[direction:ltr]" : "[direction:rtl]"
          }`}
        />
        {label && (
          <label
            htmlFor={id}
            className={`zi-floating-label pointer-events-none absolute right-0 top-0 z-10 origin-right -translate-y-1/2 rounded-lg rounded-b-none px-2.5 py-1 text-xs leading-none text-zi-blue-light/50 transition-colors duration-200 ease-in-out dark:text-zi-text-dark/50 ${
              !isReadOnly ? "dark:bg-zi-inputbg-dark" : "bg-transparent"
            }`}
          >
            {label}
          </label>
        )}
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-1">
      <label
        htmlFor={id}
        className="text-sm text-zi-text-light/50 dark:text-zi-text-dark/50"
      >
        {label}
      </label>
      <input
        defaultValue={inputSample}
        value={value}
        type={type}
        id={id}
        name={name}
        readOnly={isReadOnly}
        autoComplete={isAuotComplete}
        max={max}
        onInput={onChange}
        inputmode={isNumeric ? "numeric" : undefined}
        pattern={isNumeric ? "[0-9]*" : undefined}
        className={
          "w-full text-right bg-transparent outline-none rounded-md p-1 text-base " +
          "text-zi-text-light dark:text-zi-text-dark border-none border-zi-border-light dark:border-zi-border-dark " +
          (isReadOnly
            ? "border-opacity-0 dark:border-opacity-0 "
            : "border-opacity-100 dark:border-opacity-100 ") +
          (isReadOnly
            ? " "
            : "hocus:ring-1 hocus:ring-zi-border-light hocus:dark:ring-zi-border-dark ") +
          (isReadOnly
            ? " "
            : "hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark ") +
          (isLTR ? "[direction:ltr]" : "")
        }
      />
    </div>
  );
}
